export default __webpack_public_path__ + "static/media/Icon2.cf84fa18.svg";